import type React from "react";
import { makeStyles } from "tss-react/mui";
import { COLUMN_WIDTH } from "@miplatform/constants";
import { useDroppable } from "@dnd-kit/core";
import { Box } from "@mui/material";
import { EventSlot } from "../EventSlot/EventSlot";
import type { DeactivatedIntervalsMap, TimeInterval } from "../types";

export function DayColumn({
  adjustedHeight = 0,
  children,
  id = "",
  intervals = [],
  deactivatedIntervals,
}: Readonly<DayColumnProps>) {
  const { classes } = useStyles();
  const { setNodeRef } = useDroppable({ id });

  return (
    <Box
      data-testid="day-column"
      display="flex"
      flexDirection="column"
      flex={0}
      className={classes.column}
    >
      <Box ref={setNodeRef} className={classes.container}>
        <Box className={classes.eventsContainer}>{children}</Box>
        {intervals.map((interval) => (
          <EventSlot
            key={interval.id}
            adjustedHeight={adjustedHeight}
            deactivatedIntervals={deactivatedIntervals?.[interval.id]}
          />
        ))}
      </Box>
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  column: {
    backgroundColor: theme.palette.blue.light,
  },
  eventsContainer: {
    height: "100%",
    width: "100%",
    position: "absolute",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    position: "relative",
    width: COLUMN_WIDTH,
  },
}));

export interface DayColumnProps {
  adjustedHeight?: number;
  children?: React.ReactNode;
  id?: string;
  intervals?: TimeInterval[];
  deactivatedIntervals?: DeactivatedIntervalsMap;
}
